import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Ext from 'react-ext-state';
import {connect} from "react-redux";

import {logout} from "#app/redux/actions/auth";

import Dropdown from "./Dropdown/Dropdown";

import Avatar from '../../../UI/Avatar/Avatar';

import {AvatarContainer} from './styles';
import * as styles from "./style.module.css";

export const tgBotLink = 'https://t.me/BlackSwan_supportbot'

const Header = ({
                    auth,
                    logout
                }) => {
    const navigate = useNavigate();

    const [isFullScreen, setIsFullScreen] = useState(false);

    const mobileMenu = () => {
        Ext.setState('menu-toggle', true);
    };

    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            setIsFullScreen(true)
            document.documentElement.requestFullscreen();
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
                setIsFullScreen(false)
            }
        }
    };

    return (<>
        <div className={styles['container']}>
            <div className={styles['burger-block']}>
                {/* <Burger onPress={mobileMenu}/> */}
            </div>
            <div className={styles['content-block']}>
                <div id='header-portal' className={styles['header-portal']}/>
                {
                    auth ? (
                            <div className={styles['user-block']}>
                                <a href={'#'} onClick={(e) => {
                                    e.preventDefault()
                                    toggleFullScreen();
                                }}
                                   className={styles['fullscreen-toggle-container'] + (isFullScreen ? ' active' : '')}>
                                </a>

                                {/*
                                                                <Link className={styles['logo-block']} to='/'>
                                    <div className={styles['logo']}/>
                                    <div className={styles['title']}/>
                                </Link>
                                */}

                                <Dropdown top={'45px'} right={'-10px'} width={'auto'} links={[
                                    {
                                        id: 'avatar-menu-1',
                                        link: '/cabinet/logout', onClick: (e) => {
                                            e.preventDefault();
                                            logout({
                                                success: () => {
                                                },
                                                error: () => {

                                                },
                                                obj: this
                                            });
                                            navigate('/')
                                        },
                                        text: 'Выход'
                                    },
                                ]}>
                                    <AvatarContainer>
                                        <Avatar size={'enormous'}/>
                                    </AvatarContainer>
                                </Dropdown>

                            </div>
                        )
                        :
                        (
                            <div className={styles['login-block']}>
                                <a href="https://whiteswan.finance" className={styles['whiteswan']}>
                                    <span>Приложение для финансового учёта</span>
                                </a>
                            </div>
                        )
                }
            </div>
        </div>
    </>);
};

const enhance = connect(
    (state) => ({
        auth: state.auth.auth,
    }),
    {logout}
)

export default enhance(Header)